import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // h-9 to match icon buttons and default buttons.
    return (
      <input
        type={type}
        className={cn(
          // min-w-0 matters more than it looks: an <input> carries a browser
          // default intrinsic width (~20 characters), and w-full doesn't
          // override that minimum. Inside a grid or flex row several inputs
          // therefore refuse to shrink, overflow their container, and turn the
          // whole panel into a horizontally scrollable browser-window. Letting
          // them shrink is the root fix for side-scrolling across the app.
          "flex h-9 w-full min-w-0 rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
